import type {ScreenType} from '../types'

export const getWidthSize = (width: number): ScreenType => {
  if (width > 1024) return 'xxl'
  if (width > 768 && width < 1024) return 'xl'
  if (width > 540 && width <= 768) return 'lg'
  if (width > 480 && width <= 540) return 'md'
  if (width > 430 && width <= 480) return 'sm'
  if (width > 390 && width <= 430) return 'xs'

  return 'xxs'
}

export const getOrderWidthSize = (width: number): number => {
  if (width > 1024) return 0
  if (width > 768 && width <= 1024) return 1
  if (width > 540 && width <= 768) return 2
  if (width > 480 && width <= 540) return 3
  if (width > 430 && width <= 480) return 4
  if (width > 390 && width <= 430) return 5

  return 6
}
